
export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-steering-2-line',
      title: 'Rental Car Driving Support',
      description: 'We drive your rental car safely and comfortably. Even on unfamiliar roads, you can relax and enjoy the journey.',
      color: 'from-amber-500 to-yellow-600'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Sightseeing Travel Assist',
      description: 'We support your travel to tourist spots around Tokyo with efficient route planning for a comfortable trip.',
      color: 'from-yellow-500 to-amber-600'
    },
    {
      icon: 'ri-plane-line',
      title: 'Airport Companion Support',
      description: 'Assistance for Narita and Haneda airport transfers, with reliable schedule management aligned to your flight times.',
      color: 'from-amber-600 to-yellow-700'
    },
    {
      icon: 'ri-navigation-line',
      title: 'Parking & Highway Navigation',
      description: 'Support for complex parking facilities and highway usage. We also guide you through toll booths and ETC systems.',
      color: 'from-yellow-600 to-amber-700'
    },
    {
      icon: 'ri-building-line',
      title: 'Tokyo Local Guidance',
      description: 'Discover hidden gems, great restaurants, and local insights that only a Tokyo insider can share.',
      color: 'from-amber-700 to-yellow-800'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-black via-gray-900 to-black">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-amber-500/10 border border-amber-500/30 rounded-full px-6 py-2 mb-6">
            <span className="text-amber-400 text-sm font-semibold uppercase tracking-wider">Services</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Our Services
          </h2>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto leading-relaxed">
            Five premium services to make your rental car experience<br className="hidden md:block" />
            in Tokyo comfortable and stress-free
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="group relative bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm border border-gray-700/50 rounded-2xl p-8 hover:border-amber-500/50 transition-all duration-300 hover:shadow-xl hover:shadow-amber-500/10"
            >
              {/* Icon */}
              <div className={`w-16 h-16 flex items-center justify-center rounded-xl bg-gradient-to-br ${service.color} mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${service.icon} text-3xl text-black`}></i>
              </div>

              {/* Content */}
              <h3 className="text-xl font-bold text-white mb-4 group-hover:text-amber-400 transition-colors">
                {service.title}
              </h3>
              <p className="text-gray-300 leading-relaxed">
                {service.description}
              </p>

              {/* Decorative Element */}
              <div className="absolute top-4 right-4 w-20 h-20 bg-gradient-to-br from-amber-500/5 to-transparent rounded-full blur-2xl group-hover:from-amber-500/10 transition-all"></div>
            </div>
          ))}
        </div>

        {/* Bottom Note */}
        <div className="mt-12 text-center">
          <p className="text-gray-400 text-sm">
            * All services are provided using a rental car arranged in the guest&apos;s name.
          </p>
        </div>
      </div>
    </section>
  );
}
